import type { ReactNode } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { useI18n } from '@/core/i18n/useI18n'

export interface ConfirmDialogProps {
  open: boolean
  title: string
  message?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  /** Ação destrutiva → botão em vermelho. */
  danger?: boolean
  loading?: boolean
  onConfirm: () => void
  onClose: () => void
}

/** Confirmação genérica para ações sensíveis (excluir, aprovar, cancelar). */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  danger = false,
  loading = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  const { t } = useI18n()
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontFamily: '"Fredoka", sans-serif' }}>{title}</DialogTitle>
      {message && (
        <DialogContent>
          <DialogContentText sx={{ color: 'text.secondary' }}>{message}</DialogContentText>
        </DialogContent>
      )}
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose} disabled={loading} color="inherit">
          {cancelLabel ?? t('common.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          color={danger ? 'error' : 'primary'}
        >
          {loading ? t('components.confirmDialog.wait') : (confirmLabel ?? t('common.confirm'))}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
